/* ======================  SCRIPTS ====================== */
/************  JQUERY EST DISPONIBLE ICI *****************/

    var map;
    var iScrollPos = 0;
    var nbChampVide = 0;
    var showMapIn3D = true;
    var firstScroll = true;
    var numImgRandom = Math.floor(Math.random() * Math.floor($('.slidehome').length)) + 1;
    var navPosition;
    var mapProjectPositionTop, mapProjectPositionLeft;
    var headerHeight;
    var adaptVideoYoutubeSize;
    $('document').ready(setup);
    $(window).on('load', documentReady);

    function setup() {
        initMap();
        filtersMap();
        transformSelectbox();
        testLabelState();
        carouselCards();
        if($('#liquid').length !== 0) liquidGooey();
        $(window).on('scroll', preHeaderScroll);
        $(window).scroll(stickyMapProject);
        $(window).scroll(fixedNavigation);
        $(window).resize(changeElementsOnResize);
        $('.burger').click(showHideMenuResponsive);
        $('.btn-search').click(showHideSearchbar);
        $('.header-prehome .scrollanim').click(hidePrehome);
        $('.mapcontainer .scrollanim, .mapcontaineriframe .scrollanim').click(scrollToNextContent);
        $('.wpcf7-form .btn-contact').click(testerFormulaire);
        $('.navigation .menu .menu-item-has-children').click(showHideSubmenu);
        $('.cardproject-close').click(closeProjectCardMap);
        $('.topage, .btn-topage').click(goBackToTop);
        $('.btn-3dview').click(changeViewMap);
        $('#map a, #mapContact a').removeAttr("title");
        $('.blocwysiwyg a, .navigationpage .subnav li a').click(goestoAnchor);
        $('.btn-mapfilter').click(showMapFilters);
        $('.projectsblock .btn-load-more').click(loadMoreProjects);
        $('.newscontent .btn-load-more').click(loadMoreNews);
        $('.blocwysiwyg .btn-load-more').click(readMoreText);
        $('.projectdetails .btn-load-more').click(readMoreTextProject);
        $('.archivemagazines .btn-load-more').click(loadMoreMagazines);
        $('.pressgrid .btn-load-more').click(loadMorePressDoc);
        $('.archive-mag').click(showInfosMagazine);
        $('.navigation .menu-item-has-children').click(openSubmenuFullWidth);
        $('.shareActive').click(showShareButtons);
        $('.input-file .label').click(selectFile);
        $('.btn-showmap').click(showMapOnMobile);
        $('.cookiesGestion').attr('id', 'tarteaucitronManager');
        $('.cookiesGestion').attr('onclick', 'tarteaucitron.userInterface.openPanel();');
        if($('.gallerymedias .slider').length != 0) {
            $('.gallerymedias .slider').slick({
                dots: true,
                infinite: false,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 760,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
            $().fancybox({
                selector : '.gallerymedias .slider .slick-slide',
                backFocus : false
            });
        }
        $('.blockvideo, .blockvideo div, .blockvideo iframe, .blockvideo img').click(showVideo);
        if($('.navigationpage').length != 0) navPosition  = $('.navigationpage').offset().top - 110;
        if($('.projectdetails-map').length != 0) $('.projectdetails-map').click(showFullSizeMap);
        if($('.projectdetails-map').length != 0 && $('.projectdetails-infos').innerHeight() > 680 ) $('.projectdetails-blocs').addClass('noJustifyBottom');
        $('.cardproject:not(.hideOnDesktop)').each(function() {
            if($(this).children('.text').children('.type').children('.type-list').children('div').length > 1) $(this).children('.text').children('.type').children('.type-list').slick({
                dots: true,
                infinite: false,
                speed: 500,
                autoplay: true,
                vertical: true,
                verticalSwiping: true,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            });
        });
        $('.openSubmenu').click(showSubMenuFromBreadcrumb);
        $('#sendinbluenewsletter .btn-main').click(checkNewsletterForm);
        $('#sendinbluenewsletter-footer').submit(checkFooterNewsletterForm);
        $('#sendinbluenewsletter-footer .btn').click(checkFooterNewsletterForm);
        $('.btn-print').on('click', function() { window.print(); return false; });
        $('.content .btn-main').click(goesToAnchor);
        adaptVideoYoutubeSize = setInterval(adaptVideoSizeWysiwyg, 50);
        if(getCookie('firstLoadWebsite') == 1) {
            $('.header-prehome').remove();
            $('.navigation').removeClass('navPrehome');
            $('.navigation').addClass('active');
            $('.mapcontainer').addClass('active');
        }
        initTarteAuCitron();
        checkInstantFormFields();
    }

    function documentReady() {
        $('.header').fadeIn(600);
        $('.filtersMap').css('opacity', '1.0');
        initMapProject();
    }

    function setCookie(key, value) {
        document.cookie = key + '=' + value;
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    function goesToAnchor(e) {
        if($(this).attr('href') === '#participer') {
            e.preventDefault();
            $("html, body").animate({ scrollTop: $('#participer').offset().top - 105 }, 2000);
        }
    }

    function initTarteAuCitron() {
        tarteaucitron.init({
            "privacyUrl": "",
            "bodyPosition": "bottom",
            "hashtag": "#samoa",
            "cookieName": "samoa",
            "orientation": "middle",
            "groupServices": false,
            "showDetailsOnClick": true,
            "serviceDefaultState": "wait",
            "showAlertSmall": false,
            "cookieslist": false,
            "closePopup": false,
            "showIcon": false,
            //"iconSrc": "", /* Optionnal: URL or base64 encoded image */
            "iconPosition": "BottomRight",
            "adblocker": false,
            "DenyAllCta" : true,
            "AcceptAllCta" : true,
            "highPrivacy": true,
            "handleBrowserDNTRequest": false,
            "removeCredit": true,
            "moreInfoLink": true,
            "useExternalCss": true,
            "useExternalJs": false,
            "readmoreLink": "",
            "mandatory": true,
            "mandatoryCta": true
        });
        tarteaucitron.user.gajsUa = 'UA-7551220-1';
        tarteaucitron.user.gtagUa = 'G-Z8VWYTVTMC';
        (tarteaucitron.job = tarteaucitron.job || []).push('youtube');
        (tarteaucitron.job = tarteaucitron.job || []).push('gajs');
        (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
    }

    // Fonction qui permet d'afficher/cacher la préhome
    function preHeaderScroll(e) {
        if($('.header-prehome').length != 0) {
            e.preventDefault();
            e.stopPropagation();
            if(firstScroll == true) {
                firstScroll = false;
                setCookie("firstLoadWebsite", 1);
                $('.header-prehome').addClass('homeHide');
                $('.navigation').removeClass('navPrehome');
                $('.navigation').addClass('active');
                $('.mapcontainer').addClass('active');
                $('html, body').animate({scrollTop: 20}, 200);
                return false;
            }
        }
    }

    // Fonction qui permet de cacher la préhome au click sur le bouton souris
    function hidePrehome() {
        firstScroll = false;
        $(window).scrollTop(1);
        $('.header-prehome').addClass('homeHide');
        $('.navigation').removeClass('navPrehome');
        $('.navigation').addClass('active');
        $('.mapcontainer').addClass('active');
        return false;
    }

    // Fonction qui permet d'afficher/cacher le menu responsive
    function showHideMenuResponsive() {
        if($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.navigation .menu').removeClass('open');
        } else {
            $(this).addClass('active');
            $('.navigation .menu').addClass('open');
        }
    }

    // Fonction qui permet d'afficher les sous menu dans le menu responsive
    function showHideSubmenu() {
        if($(window).width() < 1200) {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).children('ul').slideUp(400);
            }else {
                $(this).addClass('active');
                $(this).children('ul').slideDown(400);
            }
        }
    }

    // Fonction qui permet d'afficher les sous menu en full width desktop
    function openSubmenuFullWidth(e) {
        if($(window).width() >= 1200) {
            e.preventDefault();
            var link = $(this);
            $('.showSubmenu').removeClass('showSubmenu');
            $(this).addClass('showSubmenu');
            $('.header-subnav').fadeOut(300, function() {
                var submenu = $('.showSubmenu').children('.sub-menu').html();
                $('.header-subnav .subnavfull').html(submenu);
                $('.header-subnav').fadeIn(400);
            });
            $('html, body').css('overflow', 'hidden');
            $('.closebtn').click(function() {
                $('.showSubmenu').removeClass('showSubmenu');
                $('.header-subnav').fadeOut(400);
                $('html, body').removeAttr('style');
            });
        }
    }

    function showSubMenuFromBreadcrumb() {
        var parentName = $(this).html();
        $('#mainav li').each(function() {
            if($(this).children('a').html() == parentName) {
                $(this).addClass('showSubmenu');
                $('.header-subnav').fadeOut(300, function() {
                    var submenu = $('.showSubmenu').children('.sub-menu').html();
                    $('.header-subnav .subnavfull').html(submenu);
                    $('.header-subnav').fadeIn(400);
                });
                $('html, body').css('overflow', 'hidden');
                $('.closebtn').click(function() {
                    $('.showSubmenu').removeClass('showSubmenu');
                    $('.header-subnav').fadeOut(400);
                    $('html, body').removeAttr('style');
                });
            }
        });
    }

    // Fonction qui permet d'afficher/cacher la searchbox
    function showHideSearchbar() {
       if($(this).hasClass('active')) {
           $(this).removeClass('active');
           $('.searchbox').slideUp(300);
       }else {
           $(this).addClass('active');
           $('.searchbox').slideDown(300);
           $('.searchbox-close').click(function() {
               $('.btn-search').removeClass('active');
               $('.searchbox').slideUp(300);
           });
       }
    }

    // Fonction qui permet de sticker la nav
    function fixedNavigation() {
        headerHeight = $('.header').height();

        if($(this).scrollTop() > 100) {
            $('.navigation').addClass('fixed');
            if($(window).width() < 1200) $('.header-lang').slideUp(200);
        }else {
            $('.navigation').removeClass('fixed');
            if($(window).width() < 1200) $('.header-lang').slideDown(200);
        }

        if($(window).width() >= 1200 && $(this).scrollTop() > 100) {
            var iCurScrollPos = $(this).scrollTop();
            if (iCurScrollPos > iScrollPos) {
                $('.header-lang').slideUp(200);
            } else {
                $('.header-lang').slideDown(200);
            }
            iScrollPos = iCurScrollPos;
        }

        if($(this).scrollTop() >= 1000){
            $('.btn-topage').addClass('show');
        }else {
            $('.btn-topage').removeClass('show');
        }

        // Sticker la navigation sur les pages
        if($('.navigationpage').length != 0 && $(window).width() >= 1020) {
            if($(this).scrollTop() >= navPosition && $('.navigationpage').hasClass('sticky') == false && $('.navigationpage').hasClass('stickyToBottom') == false) $('.navigationpage').addClass('sticky');
            if($(this).scrollTop() < navPosition) $('.navigationpage').removeClass('sticky');
            if($(this).scrollTop() >= ($('.pagecontent').offset().top + $('.pagecontent').innerHeight() - 800) && $('.navigationpage').hasClass('stickyToBottom') == false) {
                $('.navigationpage').fadeOut(100);
                $('.navigationpage').addClass('stickyToBottom');
            }else if($(this).scrollTop() < ($('.pagecontent').offset().top + $('.pagecontent').innerHeight() - 800) && $(this).scrollTop() >= navPosition) {
                $('.navigationpage').removeClass('stickyToBottom');
                $('.navigationpage').fadeIn(200);
            }

            var scrollTop = $(this).scrollTop();

            $('.navigationpage .subnav li').each(function() {
                var navAncer = $(this).children('a').attr('href');
                var navAncerNext = $(this).next().children('a').attr('href');
                if(navAncerNext != undefined) {
                    if(scrollTop >= ($(navAncer).offset().top - (headerHeight + 50)) && scrollTop < ($(navAncerNext).offset().top - (headerHeight + 50))) {
                        $('.navigationpage .subnav li.current').removeClass('current');
                        $(this).addClass('current');
                        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + navAncer;
                        window.history.pushState({path:newurl},'',newurl);
                    }
                }else if(scrollTop >= ($(navAncer).offset().top - (headerHeight + 50))) {
                    $('.navigationpage .subnav li.current').removeClass('current');
                    $(this).addClass('current');
                    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + navAncer;
                    window.history.pushState({path:newurl},'',newurl);
                }
            });
        }
    }

    // Fonction qui permet d'initialiser la carte en full screen sur les pages du site
    function initMap() {
        // Initialiser la carte Projets si elle est présente sur la page
        if($('.mapcontainer').length != 0 ) {
            var centerCoords = { lat: 47.20647189032169, lng: -1.54457688331604 };
            var zoom = 15;

            if($('body').hasClass('tax-quartiers')) {
                var latitude = $('.coords').attr('data-latitude');
                var longitude = $('.coords').attr('data-longitude');
                var centerCoords = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
                var zoom = 16;
            }

            var zoomLimits = {
                min: 14,
                max: 19
            };

            var tileLayer2D = 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}';
            var tileLayer3D = window.location.protocol + '//' + window.location.hostname + '/map/3d/{z}/{x}/{y}.png';

            // création des layers 2D et 3D
            window.layer2D = L.tileLayer(tileLayer2D, {
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                //detectRetina: true,
                reuseTiles: true
            });
            window.layer3D = L.tileLayer(tileLayer3D, {
                tms: true,
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                //detectRetina: true,
                reuseTiles: true
            });

            var layer = showMapIn3D == false ? layer2D : layer3D;

            map = L.map('map', {
                center: centerCoords,
                zoom: zoom,
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                touchZoom: true,
                keyboard: false,
                attributionControl: false,
                scrollWheelZoom: false,
                trackResize: true,
                fadeAnimation: true,
                zoomAnimation: true,
                layerControl: false,
                layers: [layer],
                maxBounds: [[47.22971054221563,-1.46392822265625],[-1.46392822265625,-1.62872314453125]],
            });

            // Ajouter les cluster quartiers de la homepage
            if($('.homepage').length != 0 && $('.clusterTypeOfProject').length == 0) {
                $('.clusterQuartiers li').each(function() {
                    var latitude = parseFloat($(this).attr('data-latitude'));
                    var longitude = parseFloat($(this).attr('data-longitude'));

                    if($(this).attr('data-name').length > 25) {
                        var html = "<a href='" + $(this).attr('data-url') + "' class='largerTitle'><span class='title'>" + $(this).attr('data-name') + "</span><span class='link'>Voir tous les projets</span></a>";
                    }else {
                        var html = "<a href='" + $(this).attr('data-url') + "'><span class='title'>" + $(this).attr('data-name') + "</span><span class='link'>Voir tous les projets</span></a>";
                    }

                    var myIcon = L.divIcon({
                        className: 'cluster-quartier',
                        iconSize: [135, 50],
                        html: html,
                    });

                    if(latitude && longitude) var marker = L.marker([latitude, longitude], {icon: myIcon}).addTo(map);
                });
            }

            // Ajouter les cluster des types de projet
            if($('.clusterProject').length != 0) {
                $('.clusterProject li').each(function() {
                    var latitude = parseFloat($(this).attr('data-latitude'));
                    var longitude = parseFloat($(this).attr('data-longitude'));
                    var id = $(this).attr('id');
                    var picto = $(this).attr('data-type-pictocluster');
                    var name = $(this).attr('data-name');
                    var color =  $(this).attr('data-type-color');
                    var state = $(this).attr('data-status-class');
                    var type = $(this).attr('data-type-slugs');
                    var isFromQuarter = $(this).attr('data-isfromquarter');
                    var classNotFromQuarter = 'btn-cluster';
                    if(isFromQuarter == 'no') classNotFromQuarter = 'btn-cluster-small';

                    if(name.length > 65) {
                        var html = '<button data-id="' + id + '" class="btn ' + classNotFromQuarter + ' ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name bigger-large-xxl" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length > 45) {
                        var html = '<button data-id="' + id + '" class="btn ' + classNotFromQuarter + ' ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name bigger-large" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length > 35) {
                        var html = '<button data-id="' + id + '" class="btn ' + classNotFromQuarter + ' ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name bigger" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length > 20) {
                        var html = '<button data-id="' + id + '" class="btn ' + classNotFromQuarter + ' ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name larger" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length > 15) {
                        var html = '<button data-id="' + id + '" class="btn ' + classNotFromQuarter + ' ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name intermediate" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length >= 12) {
                        var html = '<button data-id="' + id + '" class="btn ' + classNotFromQuarter + ' ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name medium" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length >= 10) {
                        var html = '<button data-id="' + id + '" class="btn ' + classNotFromQuarter + ' ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name intermediate" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else {
                        var html = '<button data-id="' + id + '" class="btn ' + classNotFromQuarter + ' ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name" style="background-color: ' + color + ';">' +  name + '</span>';
                    }

                    var myIconProject = L.divIcon({
                        className: 'cluster-project marker-' + id + ' ' + state + ' ' + type,
                        iconSize: [47, 47],
                        iconAnchor: [22, 23],
                        html: html,
                    });

                    if(latitude && longitude) {
                        var markerProject = L.marker([latitude, longitude], {icon: myIconProject}).on('click', changeCardProjectBlock).addTo(map);
                    }
                });
            }

            // Ajouter les cluster des expérimentations
            if($('.clusterExperimentations').length != 0) {
                $('.clusterExperimentations li').each(function() {
                    var latitude = parseFloat($(this).attr('data-latitude'));
                    var longitude = parseFloat($(this).attr('data-longitude'));
                    var id = $(this).attr('id');
                    var picto = $(this).attr('data-type-pictocluster');
                    var name = $(this).attr('data-name');
                    var state = $(this).attr('data-status-class');
                    var color = '#b80e80'

                    if(name.length > 65) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name bigger-large-xxl" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length > 45) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name bigger-large" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length > 35) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name bigger" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length > 20) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name larger" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length > 15) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name intermediate" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length >= 12) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name medium" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length >= 10) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name intermediate" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster ' + state + '" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name" style="background-color: ' + color + ';">' +  name + '</span>';
                    }

                    var myIconProject = L.divIcon({
                        className: 'cluster-experimentation marker-' + id + ' ' + state + ' experimentation',
                        iconSize: [47, 47],
                        iconAnchor: [22, 23],
                        html: html,
                    });

                    if(latitude && longitude) var markerExperimentation = L.marker([latitude, longitude], {icon: myIconProject}).on('click', changeCardProjectBlock).addTo(map);
                });
            }

            $('#map a').removeAttr("title");
        }

        if($('#mapcontact').length != 0) {
            var centerCoords = { lat: 47.2066, lng: -1.5638500000000022 };
            var zoom = 15;
            var zoomLimits = {
                min: 14,
                max: 18
            };
            var tileLayer2D = 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}';
            window.layer2D = L.tileLayer(tileLayer2D, {
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                //detectRetina: true,
                reuseTiles: true
            });

            var mapcontact = L.map('mapcontact', {
                center: centerCoords,
                zoom: zoom,
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                touchZoom: true,
                keyboard: false,
                attributionControl: false,
                scrollWheelZoom: false,
                trackResize: true,
                fadeAnimation: true,
                zoomAnimation: true,
                layerControl: false,
                layers: [layer2D],
                maxBounds: [[47.22971054221563,-1.46392822265625],[-1.46392822265625,-1.62872314453125]],
            });

            $('#clusterMap li').each(function() {
                var className = $(this).attr('data-class');
                var latitude = $(this).attr('data-latitude');
                var longitude = $(this).attr('data-longitude');
                var htmlText = $(this).attr('data-text');

                var myIcon = L.divIcon({
                    className: className,
                    iconSize: [45, 45],
                    iconAnchor: [23, 35],
                });

                if(latitude && longitude) L.marker([latitude, longitude], {icon: myIcon}).addTo(mapcontact).bindPopup(htmlText);
            });
        }
    }

    // Fonction qui permet de changer la vue 2D/3D de la map
    function changeViewMap() {
        if (!map.hasLayer(window.layer3D)) {
            map.removeLayer(window.layer2D);
            map.addLayer(window.layer3D);
        }else {
            map.removeLayer(window.layer3D);
            map.addLayer(window.layer2D);
        }
    }

    // Fonction qui permet de changer l'affichage de la carte projet sur la map
    function changeCardProjectBlock() {
        var clusterClass = this._icon.classList[2];
        var clusterID = clusterClass.split('marker-');
        var project = $('#' + clusterID[1]);
        $('.currentmarker').removeClass('currentmarker');
        this._icon.classList += ' currentmarker';

        // On récupère les infos du projet
        var urlDuProjet = project.attr('data-url');
        var urlImageProjet = project.attr('data-image');
        var classeStatutProjet = project.attr('data-status-class');
        var etatProjet = project.attr('data-status');
        var typeProject = project.children('.type-list').clone();
        var typeProjectColor = project.attr('data-type-color');
        var nomProjet = project.attr('data-name');
        var quartierProjet = project.attr('data-quartier');
        var quartierURLProjet = project.attr('data-quartier-url');
        var belongToQuarter = project.attr('data-isfromquarter');
        var excerptProjet = project.children('.excerpt').html();
        var descriptionProjet = project.children('.description').html();

        // On met à jour l'affichage de la carte projet
        if($('.mapcontainer .cardproject').hasClass('hideCard')) {
            if(nomProjet.length > 45)  {
                $('.mapcontainer .cardproject .text .title').addClass('larger');
            }else {
                $('.mapcontainer .cardproject .text .title').removeClass('larger');
            }
            if(belongToQuarter == 'no') {
                $('.mapcontainer .cardproject .text .btn-main').show();
            }else {
                $('.mapcontainer .cardproject .text .btn-main').hide();
            }
            $('.mapcontainer .cardproject .text .btn-blue').css('background-color', typeProjectColor);
            $('.mapcontainer .cardproject img:not(.type-pictogramme)').attr('src', urlImageProjet);
            $('.mapcontainer .cardproject img:not(.type-pictogramme)').attr('srcset', '');
            $('.mapcontainer .cardproject .text .state').removeClass('en-cours en-projet livre');
            $('.mapcontainer .cardproject .text .state').addClass(classeStatutProjet);
            $('.mapcontainer .cardproject .text .state').html(etatProjet);
            $('.mapcontainer .cardproject .text .type').html(typeProject);
            if($('.mapcontainer .cardproject .text .type-list > div').length > 1) { $('.mapcontainer .cardproject .text .type-list').slick({
                dots: true,
                infinite: false,
                speed: 500,
                autoplay: true,
                vertical: true,
                verticalSwiping: true,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            }); }
            $('.mapcontainer .cardproject .text .title .textTitle').html(nomProjet);
            $('.mapcontainer .cardproject .text .subtitle').html(quartierProjet);
            $('.mapcontainer .cardproject .text .excerpt').html(excerptProjet);
            $('.mapcontainer .cardproject .text .description').html(descriptionProjet);
            $('.mapcontainer .cardproject .text .btn-blue').attr('href', urlDuProjet);
            $('.mapcontainer .cardproject .text .btn-main').attr('href', quartierURLProjet);
            $('.mapcontainer .cardproject').removeClass('hideCard');
        }else {
            $('.mapcontainer .cardproject').addClass('hideCard');
            setTimeout(function() {
                $('.mapcontainer .cardproject .text .btn-blue').css('background-color', typeProjectColor);
                $('.mapcontainer .cardproject img:not(.type-pictogramme)').attr('src', urlImageProjet);
            }, 500);
            setTimeout(function() {
                if(nomProjet.length > 45)  {
                    $('.mapcontainer .cardproject .text .title').addClass('larger');
                }else {
                    $('.mapcontainer .cardproject .text .title').removeClass('larger');
                }
                if(belongToQuarter == 'no') {
                    $('.mapcontainer .cardproject .text .btn-main').show();
                }else {
                    $('.mapcontainer .cardproject .text .btn-main').hide();
                }
                $('.mapcontainer .cardproject img:not(.type-pictogramme)').attr('srcset', '');
                $('.mapcontainer .cardproject .text .state').removeClass('en-cours en-projet livre');
                $('.mapcontainer .cardproject .text .state').addClass(classeStatutProjet);
                $('.mapcontainer .cardproject .text .state').html(etatProjet);
                $('.mapcontainer .cardproject .text .type').html(typeProject);
                if($('.mapcontainer .cardproject .text .type-list > div').length > 1) { $('.mapcontainer .cardproject .text .type-list').slick({
                    dots: true,
                    infinite: false,
                    speed: 500,
                    autoplay: true,
                    vertical: true,
                    verticalSwiping: true,
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }); }
                $('.mapcontainer .cardproject .text .title .textTitle').html(nomProjet);
                $('.mapcontainer .cardproject .text .subtitle').html(quartierProjet);
                $('.mapcontainer .cardproject .text .excerpt').html(excerptProjet);
                $('.mapcontainer .cardproject .text .description').html(descriptionProjet);
                $('.mapcontainer .cardproject .text .btn-blue').attr('href', urlDuProjet);
                $('.mapcontainer .cardproject .text .btn-main').attr('href', quartierURLProjet);

                $('.mapcontainer .cardproject').removeClass('hideCard');
            }, 800);
        }

        if($(window).width() < 1000) {
            $('.fadebg').fadeIn(200, function() {
                $('.mapcontainer .cardproject').fadeIn();
                $('body, html').css('overflow', 'hidden');
                $('.mapcontainer .cardproject').removeClass('hideCard');
            });
        }
    }

    // Fonction qui permet de fermer la carte projet sur la map
    function closeProjectCardMap() {
        $('.currentmarker').removeClass('currentmarker');

        if($(window).width() < 1000) {
            $('.fadebg').fadeOut(300);
            $('.mapcontainer .cardproject').fadeOut();
        }else {
            $('.mapcontainer .cardproject').addClass('hideCard');
        }
    }

    // Fonction qui permet d'afficher les filtres de la carte
    function showMapFilters() {
        if($(window).width() < 576) {
            $('.mapcontainer .fadebg').fadeIn(200);
            $('body, html').css('overflow', 'hidden');
        }
        $('.filtersMap').addClass('show');
        $('.filtersMap-close').click(function() {
            $('.filtersMap').removeClass('show');
            $('.mapcontainer .fadebg').fadeOut(200);
            $('body, html').removeAttr('style');
        });
    }

    // Fonction qui permet de gérer les filtres de la carte
    function filtersMap() {
        $('.filtersMap .filter input').change(function() {
            var url = $(this).val();
            reloadMap(url, '');
        });

        $('.selectfilter input').change(function() {
            if($('#secteur').prop('checked')) {
                var url = $('#details').val();
                reloadMap(url, $(this).val());
            }

            var classTypeToShow = [];
            var classStateToShow = [];
            // On récupère le filtre par type
            $('.selectfilter-type input').each(function() {
                var classType = $(this).val();
                if($(this).prop('checked')) {
                    classTypeToShow.push(classType);
                }
            });
            // On récupère le filtre par état
            $('.selectfilter-state input').each(function() {
                var classState = $(this).val();
                if($(this).prop('checked')) {
                    classStateToShow.push(classState);
                }
            });

            // On affiche les cluster des projets qui correspondent à ces filtres
            $('#map .cluster-project, #map .cluster-experimentation').each(function() {
                var hasLeastOneTypeClass = false;
                var hasLeastOneStateClass = false;
                for (var i=0; i<classTypeToShow.length; i++) if($(this).hasClass(classTypeToShow[i])) hasLeastOneTypeClass = true;
                for (var j=0; j<classStateToShow.length; j++) if($(this).hasClass(classStateToShow[j])) hasLeastOneStateClass = true;
                if(classTypeToShow.length == 0) hasLeastOneTypeClass = true;
                if(classStateToShow.length == 0) hasLeastOneStateClass = true;

                if(hasLeastOneTypeClass == true && hasLeastOneStateClass == true) {
                    $(this).fadeIn(400);
                }else {
                    $(this).fadeOut(400);
                }
            });

            // On met à jour également l'affichage des cards projets
            var addToUrl = '?usages=';
            for (var j=0; j<classTypeToShow.length; j++) if(j == classTypeToShow.length - 1) { addToUrl += classTypeToShow[j]; }else { addToUrl += classTypeToShow[j] + ','; }
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + addToUrl;
            window.history.pushState({path:newurl},'',newurl);
            var url = window.location.href;
            $.ajax({
                url: url,
                beforeSend: function() {
                    $('.projectsblock-grid').fadeOut(200);
                },
                success: function(data) {
                    $('.projectsblock .btn-load-more').attr('data-page', '2');
                    var $projects = $(data).find('.projectsblock-grid').html();
                    var nbOfProjects = $(data).find('.cardproject').length - 1;
                    $('.projectsblock-grid').html($projects);
                    $('.projectsblock-grid').fadeIn(800);
                    if((nbOfProjects > 5 && $(data).find('.cardpush').length == 0) || (nbOfProjects >= 5 && $(data).find('.cardpush').length >= 1)) {
                        $('.projectsblock .btn-load-more').show();
                        $('.projectsblock .btn-load-more span').html('Charger plus de projet');
                        $('.projectsblock .btn-load-more').removeClass('loading');
                    }else {
                        $('.projectsblock .btn-load-more').hide();
                        var $hideOnDesktopProjects = $('.hideOnDesktop');
                        $('.hideOnDesktop').hide();
                        $('.projectsblock-grid').append($hideOnDesktopProjects);
                        $('.hideOnDesktop').removeClass('hideOnDesktop');
                    }
                    setTimeout(function () {
                        $('.cardproject').each(function() {
                            if($(this).children('.text').children('.type').children('.type-list').children('div').length > 1) $(this).children('.text').children('.type').children('.type-list').slick({
                                dots: true,
                                infinite: false,
                                speed: 500,
                                autoplay: true,
                                vertical: true,
                                verticalSwiping: true,
                                adaptiveHeight: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            });
                        });
                    }, 400);
                },
                error: function(xhr, textStatus) {
                    if(xhr.status == 404) {
                        var $hideOnDesktopProjects = $('.hideOnDesktop');
                        $('.hideOnDesktop').remove();
                        $('.projectsblock-grid').append($hideOnDesktopProjects);
                        setTimeout(function () {
                            $('.cardproject').each(function() {
                                if($(this).children('.text').children('.type').children('.type-list').children('div').length > 1) $(this).children('.text').children('.type').children('.type-list').slick({
                                    dots: true,
                                    infinite: false,
                                    speed: 500,
                                    autoplay: true,
                                    vertical: true,
                                    verticalSwiping: true,
                                    adaptiveHeight: true,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                });
                            });
                        }, 400);
                        $('.hideOnDesktop').removeClass('hideOnDesktop');
                        $('.projectsblock .btn-load-more span').html('Tous les projets sont chargés.');
                        $('.projectsblock .btn-load-more').removeClass('loading');
                        $('.projectsblock .btn-load-more').addClass('inactive');
                        $('.projectsblock .btn-load-more .icon').remove();
                    }
                }
            });
        });
    }

    // Fonction qui permet de recharger la carte au changement
    function reloadMap(url, itemChecked) {
        $.ajax({
            url: url,
            beforeSend: function() {
                $('.mapcontainer .fadebg').fadeIn(200);
                setTimeout(function() { $('.filtersMap').removeClass('show'); }, 200);
            },
            success: function(data) {
                var $map = $(data).find('.mapcontainer').html();
                $('body, html').removeAttr('style');
                $('.mapcontainer').html($map);
                $('.mapcontainer .fadebg').fadeOut(200);
                $('.mapcontainer .btn-mapfilter').click(showMapFilters);
                $('.cardproject-close').click(closeProjectCardMap);
                $('.btn-3dview').click(changeViewMap);
                $('.fullSizeMap .btn-closemap').click(function() {
                    $('.fullSizeMap').fadeOut(500, function() {
                        $('.fullSizeMap').remove();
                        $('.projectdetails-blocs').removeClass('fadeOpacity');
                        $('.shareButtons').fadeIn(300);
                        $('html, body').removeAttr('style');
                    });
                });
                $('.mapcontainer .btn-closemap').click(function() {
                    $('.mapcontainer').fadeOut(500, function() {
                        $('html, body').removeAttr('style');
                    });
                });
                initMap();
                filtersMap();
                if(itemChecked) {
                    $('.mapcontainer input').each(function() { if($(this).val() == itemChecked) $(this).attr('checked', 'checked'); });
                    $('#map .cluster-project').hide();
                    $('#map .'+ itemChecked).fadeIn(400);
                }
            },
            error: function(xhr, textStatus) {
                $('.mapcontainer .fadebg').fadeOut(200);
            }
        });
    }

    // Fonction qui permet d'activer le carousel responsive pour les cartes entrées de la home
    function carouselCards() {
        var settingsBlockCards = {
            arrows: false,
            dots: true,
            infinite: true,
            speed: 700,
            autoplay: true,
            autoplaySpeed: 1800,
            pauseOnHover: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            slide: '.blockcards-cards .card',
            responsive: [{
                breakpoint: 5000,
                settings: "unslick"
                }, {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
            }]
        };
        var blockCardsSlick =  $('.blockcards-cards').slick(settingsBlockCards);

        $(window).on('resize', function() {
            if( $(window).width() < 1200 && !blockCardsSlick.hasClass('slick-initialized')) $('.blockcards-cards').slick(settingsBlockCards);
        });
    }

    function changeElementsOnResize() {
        if($(window).width() > 1000) {
            $('.mapcontainer .fadebg').hide();
            $('html, body').removeAttr('style');
        }

        if($('.projectdetails-infos').length != 0 && $(window).width() > 1200) {
            $('.projectdetails-infos').removeAttr('style');
            $('.projectdetails-map:not(.fullSizeMap)').removeAttr('style');
            $('.projectdetails-infos').css('width', $('.projectdetails-infos').width() + 'px');
            $('.projectdetails-map:not(.fullSizeMap)').css('width', $('.projectdetails-map').innerWidth() + 'px');
        }else if($('.projectdetails-infos').length != 0) {
            $('.projectdetails-infos').removeAttr('style');
            $('.projectdetails-map:not(.fullSizeMap)').removeAttr('style');
        }
    }

    // Fonction qui permet de revenir en haut de page
    function goBackToTop() {
        $('html, body').animate({scrollTop: 0}, 1500);
    }

    // Fonction qui permet d'initialiser la mini carte sur les pages projets
    function initMapProject() {
        if($('.projectdetails').length != 0 ) {
            var centerCoords = { lat: parseFloat($('.projectdetails').attr('data-latitude')), lng: parseFloat($('.projectdetails').attr('data-longitude')) };
            var zoomLimits = {
                min: 14,
                max: 19
            };

            var tileLayer2D = 'https://api.mapbox.com/styles/v1/gingerminds/cjw1uzs7p01qw1cqk2hm85p19/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZ2luZ2VybWluZHMiLCJhIjoiY2p3MXRteGhoMDA1azRhbzU4Njh6eWxociJ9.ZfaRUBFMImXnS2mCjC2BTg';
            var tileLayer3D = window.location.protocol + '//' + window.location.hostname + '/map/3d/{z}/{x}/{y}.png';

            // création des layers 2D et 3D
            window.layer2D = L.tileLayer(tileLayer2D, {
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                //detectRetina: true,
                reuseTiles: true
            });
            window.layer3D = L.tileLayer(tileLayer3D, {
                tms: true,
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                //detectRetina: true,
                reuseTiles: true
            });
            var layer = showMapIn3D == false ? layer2D : layer3D;

            var mapProject = L.map('map-project', {
                center: centerCoords,
                zoom: 15,
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                touchZoom: true,
                keyboard: false,
                attributionControl: false,
                scrollWheelZoom: false,
                trackResize: true,
                fadeAnimation: true,
                zoomAnimation: true,
                layerControl: false,
                layers: [layer],
                maxBounds: [[47.22971054221563,-1.46392822265625],[-1.46392822265625,-1.62872314453125]],
            });
            var picto = $('.projectdetails').attr('data-cluster');
            var html = '<button class="btn btn-cluster" style="background-image: url(' + picto + ');"></button>';

            var myIcon = L.divIcon({
                className: 'cluster-project',
                iconSize: [70, 70],
                iconAnchor: [35, 70],
                html: html,
            });

            var markerProject = L.marker([parseFloat($('.projectdetails').attr('data-latitude')), parseFloat($('.projectdetails').attr('data-longitude'))], {icon: myIcon}).addTo(mapProject);
            markerProject.setZIndexOffset(100);

            // Ajouter les cluster des types de projet
            if($('.clusterProject').length != 0) {
                $('.clusterProject li').each(function() {
                    var latitude = parseFloat($(this).attr('data-latitude'));
                    var longitude = parseFloat($(this).attr('data-longitude'));
                    var picto = $(this).attr('data-type-pictocluster');
                    var html = '<button class="btn btn-cluster-small" style="background-image: url(' + picto + ');"></button>';

                    var myIcon = L.divIcon({
                        className: 'cluster-project',
                        iconSize: [35, 35],
                        iconAnchor: [16, 35],
                        html: html,
                    });

                    if(latitude && longitude) {
                        var markerProjectAround = L.marker([latitude, longitude], {icon: myIcon}).addTo(mapProject);
                        markerProjectAround.setZIndexOffset(50);
                    }
                });
            }

            $('#map a').removeAttr("title");
        }
    }

    // Fonction qui permet d'agrandir la map sur les fiches opérations
    function showFullSizeMap() {
        $('.projectdetails-map').clone().appendTo('.projectdetails-blocs').addClass('fullSizeMap');
        $('.fullSizeMap  #map-project').remove();
        $('.projectdetails-blocs').addClass('fadeOpacity');
        $('.fullSizeMap').removeAttr('style');
        $('.fullSizeMap').removeClass('attachedToBottom');
        $('.fullSizeMap').append('<div id="map-project-zoom"></div>');
        $('.fullSizeMap').append('<button class="btn-closemap">Réduire la carte</button>');
        $('html, body').css('overflow', 'hidden');
        $('.fullSizeMap').fadeIn(500, function() {
            var centerCoords = { lat: parseFloat($('.projectdetails').attr('data-latitude')), lng: parseFloat($('.projectdetails').attr('data-longitude')) };
            var zoomLimits = {
                min: 14,
                max: 18
            };

            var tileLayer2D = 'https://api.mapbox.com/styles/v1/gingerminds/cjw1uzs7p01qw1cqk2hm85p19/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZ2luZ2VybWluZHMiLCJhIjoiY2p3MXRteGhoMDA1azRhbzU4Njh6eWxociJ9.ZfaRUBFMImXnS2mCjC2BTg';
            var tileLayer3D = window.location.protocol + '//' + window.location.hostname + '/map/3d/{z}/{x}/{y}.png';

            // création des layers 2D et 3D
            window.layer2D = L.tileLayer(tileLayer2D, {
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                //detectRetina: true,
                reuseTiles: true
            });
            window.layer3D = L.tileLayer(tileLayer3D, {
                tms: true,
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                //detectRetina: true,
                reuseTiles: true
            });
            var layer = showMapIn3D == false ? layer2D : layer3D;

            var mapProjectZoom = L.map('map-project-zoom', {
                center: centerCoords,
                zoom: 17,
                minZoom: zoomLimits.min,
                maxZoom: zoomLimits.max,
                touchZoom: true,
                keyboard: false,
                attributionControl: false,
                scrollWheelZoom: false,
                trackResize: true,
                fadeAnimation: true,
                zoomAnimation: true,
                layerControl: false,
                layers: [layer],
                maxBounds: [[47.22971054221563,-1.46392822265625],[-1.46392822265625,-1.62872314453125]],
            });
            var picto = $('.projectdetails').attr('data-cluster');
            var name = $('.projectdetails').attr('data-name');
            var color = $('.projectdetails').attr('data-color');

            if(name.length > 65) {
                var html = '<button class="btn btn-cluster" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name bigger-large-xxl" style="background-color: ' + color + ';">' +  name + '</span>';
            }else if(name.length > 45) {
                var html = '<button class="btn btn-cluster" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name bigger-large" style="background-color: ' + color + ';">' +  name + '</span>';
            }else if(name.length > 35) {
                var html = '<button class="btn btn-cluster" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name bigger" style="background-color: ' + color + ';">' +  name + '</span>';
            }else if(name.length > 20) {
                var html = '<button class="btn btn-cluster" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name larger" style="background-color: ' + color + ';">' +  name + '</span>';
            }else if(name.length > 15) {
                var html = '<button class="btn btn-cluster" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name intermediate" style="background-color: ' + color + ';">' +  name + '</span>';
            }else if(name.length >= 12) {
                var html = '<button class="btn btn-cluster" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name medium" style="background-color: ' + color + ';">' +  name + '</span>';
            }else if(name.length >= 10) {
                var html = '<button class="btn btn-cluster" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name intermediate" style="background-color: ' + color + ';">' +  name + '</span>';
            }else {
                var html = '<button class="btn btn-cluster" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name" style="background-color: ' + color + ';">' +  name + '</span>';
            }

            var myIcon = L.divIcon({
                className: 'cluster-project',
                iconSize: [75, 75],
                iconAnchor: [37, 75],
                html: html,
            });

            if($('.projectdetails').attr('data-latitude') && $('.projectdetails').attr('data-longitude')) {
                var markerProject = L.marker([parseFloat($('.projectdetails').attr('data-latitude')), parseFloat($('.projectdetails').attr('data-longitude'))], {icon: myIcon}).addTo(mapProjectZoom);
                markerProject.setZIndexOffset(100);
            }

            // Ajouter les cluster des types de projet
            if($('.clusterProject').length != 0) {
                $('.clusterProject li').each(function() {
                    var latitude = parseFloat($(this).attr('data-latitude'));
                    var longitude = parseFloat($(this).attr('data-longitude'));
                    var id = $(this).attr('id');
                    var picto = $(this).attr('data-type-pictocluster');
                    var name = $(this).attr('data-name');
                    var color =  $(this).attr('data-type-color');

                    if(name.length > 45) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster-small" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name bigger-large" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length > 35) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster-small" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name bigger" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length > 20) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster-small" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name larger" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length > 15) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster-small" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name intermediate" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length >= 12) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster-small" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name medium" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else if(name.length >= 10) {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster-small" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name intermediate" style="background-color: ' + color + ';">' +  name + '</span>';
                    }else {
                        var html = '<button data-id="' + id + '" class="btn btn-cluster-small" style="background-image: url(' + picto + ');"><span class="sr-only">' + name + '</span></button><span class="name" style="background-color: ' + color + ';">' +  name + '</span>';
                    }

                    var myIcon = L.divIcon({
                        className: 'cluster-project marker-' + id,
                        iconSize: [40, 40],
                        iconAnchor: [16, 40],
                        html: html,
                    });

                    if(latitude && longitude) {
                        var markerProjectAround = L.marker([latitude, longitude], {icon: myIcon}).on('click', showProject).addTo(mapProjectZoom);
                        markerProjectAround.setZIndexOffset(50);
                    }
                });
            }

            $('#map-project-zoom a').removeAttr("title");
        });
        $('.shareButtons').fadeOut(300);
        $('.fullSizeMap .btn-closemap').click(function() {
            $('.fullSizeMap').fadeOut(500, function() {
                $('.fullSizeMap').remove();
                $('.projectdetails-blocs').removeClass('fadeOpacity');
                $('.shareButtons').fadeIn(300);
                $('html, body').removeAttr('style');
            });
        });
    }

    // Fonction qui permet d'afficher un autre projet depuis la mini map quartier d'un projet
    function showProject() {
        var clusterClass = this._icon.classList[2];
        var clusterID = clusterClass.split('marker-');
        var project = $('#' + clusterID[1]);
        window.location = project.attr('data-url');
    }

    // Fonction qui permet d'afficher la vidéo du bloc Vidéo
    function showVideo() {
        $('.blockvideo').addClass('showVideo');
    }

    // Fonction qui permet de charger plus de projets dans la liste des projets
    function loadMoreProjects() {
        if($('.projectsblock .btn-load-more').hasClass('inactive') == false && $('.projectsblock .btn-load-more').hasClass('loading') == false) {
            var numPage = $(this).attr('data-page');
            if(window.location.href.indexOf('?usages=') != -1) {
                var getfilterByType = window.location.href.split('?usages=');
                var filterByType = getfilterByType[1].split(',');
                var url = window.location.href.split('?')[0] + '?paged=' + numPage + '&usages=';
                for (var j=0; j<filterByType.length; j++) if(j == filterByType.length - 1) { url += filterByType[j]; }else { url += filterByType[j] + ','; }
            }else {
                var url = window.location.href + '?paged=' + numPage;
            }
            $.ajax({
                url: url,
                beforeSend: function() {
                    $('.projectsblock .btn-load-more span').html('Chargement en cours...');
                    $('.projectsblock .btn-load-more').addClass('loading');
                },
                success: function(data) {
                    $('.projectsblock .btn-load-more').attr('data-page', parseInt(numPage) + 1);
                    $('.projectsblock-grid').fadeOut(200, function() {
                        var $projects = $(data).find('.projectsblock-grid').html();
                        var nbOfProjects = $(data).find('.cardproject').length;
                        $('.projectsblock-grid').append($projects);
                        $('.projectsblock-grid').fadeIn(800);
                        if((nbOfProjects > 5 && $(data).find('.cardpush').length == 0) || (nbOfProjects >= 5 && $(data).find('.cardpush').length >= 1)) {
                            $('.projectsblock .btn-load-more span').html('Charger plus de projet');
                            $('.projectsblock .btn-load-more').removeClass('loading');
                        }else {
                            $('.projectsblock .btn-load-more').remove();
                            var $hideOnDesktopProjects = $('.hideOnDesktop');
                            $('.hideOnDesktop').remove();
                            $('.projectsblock-grid').append($hideOnDesktopProjects);
                            $('.hideOnDesktop').removeClass('hideOnDesktop');
                        }
                        setTimeout(function () {
                            $('.cardproject').each(function() {
                                if($(this).children('.text').children('.type').children('.type-list').children('div').length > 1) $(this).children('.text').children('.type').children('.type-list').slick({
                                    dots: true,
                                    infinite: false,
                                    speed: 500,
                                    autoplay: true,
                                    vertical: true,
                                    verticalSwiping: true,
                                    adaptiveHeight: true,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                });
                            });
                        }, 400);
                    });
                },
                error: function(xhr, textStatus) {
                    if(xhr.status == 404) {
                        var $hideOnDesktopProjects = $('.hideOnDesktop');
                        $('.hideOnDesktop').remove();
                        $('.projectsblock-grid').append($hideOnDesktopProjects);
                        setTimeout(function () {
                            $('.cardproject').each(function() {
                                if($(this).children('.text').children('.type').children('.type-list').children('div').length > 1) $(this).children('.text').children('.type').children('.type-list').slick({
                                    dots: true,
                                    infinite: false,
                                    speed: 500,
                                    autoplay: true,
                                    vertical: true,
                                    verticalSwiping: true,
                                    adaptiveHeight: true,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                });
                            });
                        }, 400);
                        $('.hideOnDesktop').removeClass('hideOnDesktop');
                        $('.projectsblock .btn-load-more span').html('Tous les projets sont chargés.');
                        $('.projectsblock .btn-load-more').removeClass('loading');
                        $('.projectsblock .btn-load-more').addClass('inactive');
                        $('.projectsblock .btn-load-more .icon').remove();
                    }
                }
            });
        }
    }

    // Fonction qui permet de charger plus de news
    function loadMoreNews() {
        if($('.btn-load-more').hasClass('inactive') === false && $('.btn-load-more').hasClass('loading') === false) {
            var numPage = $(this).attr('data-page');
            if(window.location.href.indexOf('?') != -1) {
                var url = window.location.href.split('?');
                var urlAjax = url[0] + '?paged=' + numPage + '&' + url[1];
            }else {
                var urlAjax = window.location.href + '?paged=' + numPage;
            }

            $.ajax({
                url: urlAjax,
                beforeSend: function() {
                    $('.btn-load-more span').html('Chargement en cours...');
                    $('.btn-load-more').addClass('loading');
                },
                success: function(data) {
                    $('.btn-load-more').attr('data-page', parseInt(numPage) + 1);
                    $('.newsgrid').fadeOut(200, function() {
                        $('.hideOnDesktop').removeClass('hideOnDesktop');
                        var $news = $(data).find('.newsgrid').html();
                        var nbOfNews = $(data).find('.cardnews').length;
                        var nbToNewsToShow = $('.filters-number .current a').html();
                        console.log(nbOfNews);
                        $('.newsgrid').append($news);
                        $('.newsgrid').fadeIn(800);
                        if(nbOfNews >= parseInt(nbToNewsToShow)) {
                            $('.btn-load-more span').html('Charger plus d\'actualité');
                            $('.btn-load-more').removeClass('loading');
                        }else {
                            $('.btn-load-more').remove();
                        }
                    });
                },
                error: function(xhr, textStatus) {
                    if(xhr.status == 404) {
                        $('.hideOnDesktop').removeClass('hideOnDesktop');
                        $('.btn-load-more span').html('Toutes les actualités sont chargées.');
                        $('.btn-load-more').removeClass('loading');
                        $('.btn-load-more').addClass('inactive');
                        $('.btn-load-more .icon').remove();
                    }
                }
            });
        }
    }

    // Fonction qui permet de charger plus de magazines sur la page Magazine Transformation(s)
    function loadMoreMagazines() {
        if($('.btn-load-more').hasClass('inactive') == false && $('.btn-load-more').hasClass('loading') == false) {
            var numPage = $(this).attr('data-page');
            if($('.archivemagazines').attr('data-page') != undefined) {
                var url = $('.archivemagazines').attr('data-page') + '?paged=' + numPage;
            }else {
                var url = window.location.href + '?paged=' + numPage;
            }
            $.ajax({
                url: url,
                beforeSend: function() {
                    $('.btn-load-more span').html('Chargement en cours...');
                    $('.btn-load-more').addClass('loading');
                },
                success: function(data) {
                    $('.btn-load-more').attr('data-page', parseInt(numPage) + 1);
                    $('.archivemagazines .archive').fadeOut(200, function() {
                        var $magazines = $(data).find('.archive').html();
                        var nbOfMagazines = $(data).find('.archive-mag').length;
                        $('.archivemagazines .archive').append($magazines);
                        $('.archivemagazines .archive').fadeIn(800);
                        $('.archive-mag:not(.js-istarget)').click(showInfosMagazine);
                        $('.archive-mag:not(.js-istarget)').addClass('js-istarget');
                        if(nbOfMagazines >= 8) {
                            $('.btn-load-more span').html('Charger plus de numéros');
                            $('.btn-load-more').removeClass('loading');
                        }else {
                            $('.btn-load-more').remove();
                        }
                    });
                },
                error: function(xhr, textStatus) {
                    if(xhr.status == 404) {
                        $('.btn-load-more span').html('Tous les magazines sont chargés.');
                        $('.btn-load-more').removeClass('loading');
                        $('.btn-load-more').addClass('inactive');
                        $('.btn-load-more .icon').remove();
                    }
                }
            });
        }
    }

    // Fonction qui permet d'afficher la modale avec les infos d'un magazine Transformation(s)
    function showInfosMagazine() {
        var idMagazine = $(this).attr('data-id');
        var url = window.location.href + '?mag=' + idMagazine;
        $.ajax({
            url: url,
            beforeSend: function() {
                $('html, body').css('overflow', 'hidden');
                $('.fadelight').fadeIn(200);
            },
            success: function(data) {
                var $magazineInfo = $(data).find('.modalMagazine');
                $('.transfopage').append($magazineInfo);
                setTimeout(function() { $('.modalMagazine').addClass('show'); $('.fadelight img').fadeOut(200); }, 200);
                $('.modalMagazine .close').click(function() {
                    $('.modalMagazine').removeClass('show');
                    setTimeout(function() {
                        $('html, body').removeAttr('style');
                        $('.fadelight').fadeOut(300);
                        $('.modalMagazine').remove();
                        $('.fadelight img').fadeIn(500);
                    }, 400);
                });
            },
            error: function(xhr, textStatus) {
                $('html, body').removeAttr('style');
                $('.fadelight').fadeOut(300);
                $('.fadelight img').fadeIn(500);
            }
        });
    }

    // Fonction qui permet de charger plus de documents presse
    function loadMorePressDoc() {
        if($('.btn-load-more').hasClass('inactive') == false && $('.btn-load-more').hasClass('loading') == false) {
            var numPage = $(this).attr('data-page');
            if(window.location.href.indexOf('?') != -1) {
                var url = window.location.href.split('?');
                var urlAjax = url[0] + '?paged=' + numPage + '&' + url[1];
            }else {
                var urlAjax = window.location.href + '?paged=' + numPage;
            }
            $.ajax({
                url: urlAjax,
                beforeSend: function() {
                    $('.btn-load-more span').html('Chargement en cours...');
                    $('.btn-load-more').addClass('loading');
                },
                success: function(data) {
                    $('.btn-load-more').attr('data-page', parseInt(numPage) + 1);
                    $('.pressgrid-cards').fadeOut(200, function() {
                        var $documents = $(data).find('.pressgrid-cards').html();
                        var nbOfDocuments = $(data).find('.cardpress').length;
                        $('.pressgrid-cards').append($documents);
                        $('.pressgrid-cards').fadeIn(800);
                        var nbDocumentsShowed = $('.cardpress').length;
                        $('.filters-infos b').html(nbDocumentsShowed + ' documents de presse');
                        $('.hideOnDesktop').removeClass('hideOnDesktop');
                        $('.showOnDesktop').removeClass('showOnDesktop');
                        if(nbDocumentsShowed != parseInt($('.filters-infos span').html())) {
                            $('.btn-load-more span').html('Charger plus de documents');
                            $('.btn-load-more').removeClass('loading');
                        }else {
                            $('.btn-load-more span').html('Tous les documents sont chargés.');
                            $('.btn-load-more').removeClass('loading');
                            $('.btn-load-more').addClass('inactive');
                            $('.btn-load-more .icon').remove();
                        }
                    });
                },
                error: function(xhr, textStatus) {
                    if(xhr.status == 404) {
                        $('.hideOnDesktop').removeClass('hideOnDesktop');
                        $('.showOnDesktop').removeClass('showOnDesktop');
                        var nbDocumentsShowed = $('.cardpress').length;
                        $('.filters-infos b').html(nbDocumentsShowed + ' documents de presse');
                        $('.btn-load-more span').html('Tous les documents sont chargés.');
                        $('.btn-load-more').removeClass('loading');
                        $('.btn-load-more').addClass('inactive');
                        $('.btn-load-more .icon').remove();
                    }
                }
            });
        }
    }

    // Fonction qui permet de transformer les champ select
    function transformSelectbox() {
        if($('.selectBox').length != 0) {
            $('.selectBox-selected').click(function() {
                if($(this).hasClass('open')) {
                    $(this).removeClass('open');
                    $('.selectBox .selectBox-items').slideUp();
                }else {
                    $(this).addClass('open');
                    $('.selectBox .selectBox-items').slideDown();
                }
            });
            $('.selectBox .selectBox-items li').click(function() {
                if($(this).hasClass('selected') == false) {
                    $('.selectBox .selectBox-items .selected').removeClass('selected');
                    $(this).addClass('selected');
                    $('.selectBox-selected').html($(this).text());
                    $('.selectBox-selected').removeClass('open');
                    $('.selectBox .selectBox-items').slideUp();
                    var value = $(this).attr('data-value');
                    $('.selectBox select option').each(function() {
                        $(this).removeAttr('selected');
                        if($(this).val() == value) $(this).attr("selected","selected");
                    });
                }
            });
        }
    }

    // Fonction qui permet de gérer l'affichage des labels si un champ input est complété
    function testLabelState() {
        $("input").blur(function() {
            if ($(this).val() != "" && $(this).val() != " ") {
                $(this).next().addClass('focus');
            }else {
                $(this).next().removeClass('focus');
            }
        });

        $("select").change(function() {
            if ($(this).val() != "" && $(this).val() != " ") {
                $(this).prev().addClass('focus');
                $(this).removeClass('error');
                $(this).addClass('valid');
                $(this).parent().children('.error-msg').fadeOut(300);
            }else {
                $(this).prev().removeClass('focus');
                $(this).addClass('error');
                $(this).removeClass('valid');
                $(this).parent().children('.error-msg').fadeIn(300);
            }
        });
    }

    function testerFormulaire(e) {
        e.preventDefault();

        // vérification des saisies utilisateurs
        nbChampVide = 0;
        $('.error-msg').fadeOut(200);
        $('select.error').removeClass('error');
        $('select.valid').removeClass('valid');
        $('input.error').removeClass('error');
        $('input.valid').removeClass('valid');

        // On vérifie que l'utilisateur a coché les cases RGPD
        if($('input[name="rgpd[]"]').prop( "checked" ) == false) {
            $('input[name="rgpd[]"]').parent().parent().parent().parent().children('.error-msg').fadeIn(300);
            nbChampVide++;
        }

        // On vérifie s'il y a des select list obligatoire
        $('select.wpcf7-validates-as-required').each(function () {
            if($(this).val() == '' || $(this).val() == ' ') {
                $(this).addClass('error');
                $(this).parent().children('.error-msg').fadeIn(300);
                nbChampVide++;
            }else {
                $(this).addClass('valid');
            }
        });

        // On vérifie la saisie des champs obligatoire
        $('.form input.wpcf7-validates-as-required, .wpcf7-form input.wpcf7-validates-as-required').each(function() {
            if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                nbChampVide++;
                $(this).addClass('error');
                $(this).parent().children('.error-msg').fadeIn(300);
            }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                var name = $(this).attr('name');
                if(name == 'email') {
                    var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
                    if (regex.test($(this).val()) == false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                    }
                }else if(name == 'telephone') {
                    var regexPhone = /^((\+|00)33\s?|0)[1-7](\s?\d{2}){4}$/;
                    if (regexPhone.test($(this).val()) == false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                    }
                }else if(name == 'code_postal') {
                    var regexCodePostal = /[0-9]{5,5}/igm;
                    if (regexCodePostal.test($(this).val()) == false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                    }
                }else if(name == 'ville') {
                    var regexVille = /^[a-zA-Zéèïîê]+[a-zA-Zéèïîê \-]+[a-zA-Zéèïîê \-]$/igm;
                    if (regexVille.test($(this).val()) == false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                    }
                }else {
                    $(this).addClass('valid');
                }
            }
        });

        // On vérifie que les textarea requis sont renseignés
        $('.form textarea.wpcf7-validates-as-required, .wpcf7-form textarea.wpcf7-validates-as-required').each(function() {
            if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                nbChampVide++;
                $(this).addClass('error');
                $(this).parent().children('.error-msg').fadeIn(300);
            }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                $(this).addClass('valid');
            }
        });

        // Si le téléphone est renseigné, on vérifie qu'il est valide
        $('.form .wpcf7-tel, .wpcf7-tel').each(function() {
            if($(this).val() != "" && $(this).val() != " ") {
                var regex = /^((\+|00)33\s?|0)[1-7](\s?\d{2}){4}$/;
                if (regex.test($(this).val()) == false) {
                    nbChampVide++;
                    $(this).addClass('error');
                    $(this).parent().children('.error-msg').fadeIn(300);
                }else {
                    $(this).addClass('valid');
                    $(this).parent().children('.error-msg').fadeOut(300);
                }
            }
        });

        if(nbChampVide !== 0) {
            $("html, body").animate({ scrollTop: $('.error').offset().top - 125 }, 500);
        }else {
            $.ajax({
                type: "POST",
                url: $('.form, .wpcf7-form').attr('action'),
                data: $('.form, .wpcf7-form').serialize(), // serializes the form's elements.
                beforeSend: function() {
                    $('.form, .wpcf7-form').css('opacity', '0');
                    $('.contactct-form .fadeLoad').fadeIn(500);
                    $("html, body").animate({ scrollTop: $('.wpcf7-form').offset().top - 125 }, 500);
                },
                success: function(data) {
                    gtag('event', 'contact_form_submission');
                    if($('#newsletter input').prop('checked') === true) {
                        var email_newsletter = $('.wpcf7-form input[name="email"]').val();
                        $.ajax({
                            type: "GET",
                            url: window.location.protocol + '//' + window.location.hostname + '/wp-content/themes/samoa/sendinblue/newsletter.php?botOrNotBot_newsletter=imNotBot&email_newsletter='+email_newsletter+'&list_newsletter=15',
                            success: function(data) {
                                gtag('event', 'newsletter_subscription');
                                $('.form, .wpcf7-form').slideUp(400);
                                $('.contactct-form .fadeLoad').fadeOut(400);
                                $('.contactct-form .validmessage').fadeIn(400);
                            },
                            error: function(xhr, textStatus) {
                                $('.form, .wpcf7-form').slideUp(400);
                                $('.contactct-form .fadeLoad').fadeOut(400);
                                $('.contactct-form .errormessage').fadeIn(400);
                            }
                        });
                    }else {
                        $('.form, .wpcf7-form').slideUp(400);
                        $('.contactct-form .fadeLoad').fadeOut(400);
                        $('.contactct-form .validmessage').fadeIn(400);
                    }
                },
                error: function(xhr, textStatus) {
                    $('.form, .wpcf7-form').slideUp(400);
                    $('.contactct-form .fadeLoad').fadeOut(400);
                    $('.contactct-form .errormessage').fadeIn(400);
                }
            });
        }
    }

    // Vérification à la volée des champs du formulaire de contact
    function checkInstantFormFields() {
        $('.form input.wpcf7-validates-as-required, .wpcf7-form input.wpcf7-validates-as-required').focusout(function() {
            if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                nbChampVide++;
                $(this).addClass('error');
                $(this).removeClass('valid');
                $(this).parent().children('.error-msg').fadeIn(300);
            }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                var name = $(this).attr('name');
                if(name == 'email') {
                    var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
                    if (regex.test($(this).val()) == false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).removeClass('valid');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                        $(this).removeClass('error');
                        $(this).parent().children('.error-msg').fadeOut(300);
                    }
                }else if(name == 'telephone') {
                    var regexPhone = /^((\+|00)33\s?|0)[1-7](\s?\d{2}){4}$/;
                    if (regexPhone.test($(this).val()) == false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).removeClass('valid');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                        $(this).removeClass('error');
                        $(this).parent().children('.error-msg').fadeOut(300);
                    }
                }else if(name == 'code_postal') {
                    var regexCodePostal = /[0-9]{5,5}/igm;
                    if (regexCodePostal.test($(this).val()) == false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).removeClass('valid');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                        $(this).removeClass('error');
                        $(this).parent().children('.error-msg').fadeOut(300);
                    }
                }else if(name == 'ville') {
                    var regexVille = /^[a-zA-Zéèïîê]+[a-zA-Zéèïîê \-]+[a-zA-Zéèïîê \-]$/igm;
                    if (regexVille.test($(this).val()) == false) {
                        nbChampVide++;
                        $(this).addClass('error');
                        $(this).removeClass('valid');
                        $(this).parent().children('.error-msg').fadeIn(300);
                    }else {
                        $(this).addClass('valid');
                        $(this).removeClass('error');
                        $(this).parent().children('.error-msg').fadeOut(300);
                    }
                }else {
                    $(this).addClass('valid');
                    $(this).removeClass('error');
                    $(this).parent().children('.error-msg').fadeOut(300);
                }
            }
        });
        $('.form textarea.wpcf7-validates-as-required, .wpcf7-form textarea.wpcf7-validates-as-required').focusout(function() {
            if($(this).val() == "" || $(this).val() == " ") { // On vérifie que le champ n'est pas vide
                nbChampVide++;
                $(this).addClass('error');
                $(this).removeClass('valid');
                $(this).parent().children('.error-msg').fadeIn(300);
            }else { // S'il n'est pas vide on vérifie s'il y a une verification supplémentaire sur le champ
                $(this).addClass('valid');
                $(this).removeClass('error');
                $(this).parent().children('.error-msg').fadeOut(300);
            }
        });
        $('.form .wpcf7-tel, .wpcf7-tel').focusout(function() {
            if($(this).val() != "" && $(this).val() != " ") {
                var regex = /^((\+|00)33\s?|0)[1-7](\s?\d{2}){4}$/;
                if (regex.test($(this).val()) == false) {
                    nbChampVide++;
                    $(this).addClass('error');
                    $(this).removeClass('valid');
                    $(this).parent().children('.error-msg').fadeIn(300);
                }else {
                    $(this).addClass('valid');
                    $(this).removeClass('error');
                    $(this).parent().children('.error-msg').fadeOut(300);
                }
            }
        });

        $('input[name="code_postal"]').keypress(function () {
            var maxLength = $(this).val().length;
            if (maxLength >= 5) {
                return false;
            }
        });
    }

    // Fonction qui permet d'ajotuer des utilisateurs à la newsletter Send in Blue
    function checkNewsletterForm(e) {
        e.preventDefault();
        $('.newsletterblock .error-msg').fadeOut(100);
        var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
        if (regex.test($('#email-newsletter').val()) === false) {
            $(this).parent().children('.error-msg').fadeIn(300);
        }else {
            $('#sendinbluenewsletter input[name="botOrNotBot_newsletter"]').val('imNotBot');
            $.ajax({
                type: "GET",
                url: $('#sendinbluenewsletter').attr('action'),
                data: $('#sendinbluenewsletter').serialize(), // serializes the form's elements.
                beforeSend: function() {
                    $('.fadebg').fadeIn(200);
                },
                success: function(data) {
                    gtag('event', 'newsletter_subscription');
                    $('#sendinbluenewsletter .error-msg').fadeOut(100, function() {
                        $('#sendinbluenewsletter .error-msg').html('Merci ! Votre inscription a bien été prise en compte !');
                        $('#sendinbluenewsletter .error-msg').addClass('validMsg');
                        $('#sendinbluenewsletter .error-msg').removeClass('error-msg');
                        $('#sendinbluenewsletter .validMsg').fadeIn(200);
                        $('.fadebg').fadeOut(200);
                    });
                    $('#sendinbluenewsletter input, #sendinbluenewsletter .btn').fadeOut(200);
                },
                error: function() {
                    $('#sendinbluenewsletter .error-msg').html('Votre inscription n\'a pas pu être validée, merci de réessayer.');
                    $('#sendinbluenewsletter .error-msg').fadeIn(200);
                }
            });
        }
    }

    function checkFooterNewsletterForm(e) {
        e.preventDefault();
        $('#sendinbluenewsletter-footer .error-msg').fadeOut(100);
        var regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
        if (regex.test($('#email_newsletter').val()) == false) {
            $(this).parent().children('.error-msg').fadeIn(300);
        }else {
            $('#sendinbluenewsletter-footer input[name="botOrNotBot_newsletter"]').val('imNotBot');
            $.ajax({
                type: "GET",
                url: $('#sendinbluenewsletter-footer').attr('action'),
                data: $('#sendinbluenewsletter-footer').serialize(), // serializes the form's elements.
                beforeSend: function() {
                    $('.fadebg').fadeIn(200);
                },
                success: function(data) {
                    gtag('event', 'newsletter_subscription');
                    $('#sendinbluenewsletter-footer input, #sendinbluenewsletter-footer .btn').fadeOut(200);
                    $('#sendinbluenewsletter-footer .error-msg').html('Merci ! Votre inscription a bien été prise en compte !');
                    $('#sendinbluenewsletter-footer .error-msg').addClass('validMsg');
                    $('#sendinbluenewsletter-footer .error-msg').fadeIn(200);
                    $('#sendinbluenewsletter-footer .error-msg').removeClass('error-msg');
                    $('.fadebg').fadeOut(200);
                },
                error: function() {
                    $('#sendinbluenewsletter-footer .error-msg').html('Votre inscription n\'a pas pu être validée, merci de réessayer.');
                    $('#sendinbluenewsletter-footer .error-msg').fadeIn(200);
                }
            });
        }
    }

    // Fonction qui permet d'envoyer une pièce jointe
    function selectFile() {
        $(this).parent().children('input').click();
        $(this).parent().children('input').on( "change", function( event ) {
            var splitFileName = this.value.split('.');
            var fileType = splitFileName[splitFileName.length - 1].toLowerCase();
            var fileSize = this.files[0].size;
            if(fileType === 'jpg' || fileType === 'jpeg' || fileType === 'png' || fileType === 'pdf' || fileType === 'docx' || fileType === 'doc' || fileType === 'csv' || fileType === 'xls' || fileType === 'xlsx') {
                if (this.files[0].size > 2000000) {
                    $('.file-return span').html('');
                    $('.file-return').fadeOut(300);
                    $('.input-file .error-msg').html('La taille du fichier dépasse 2MB. Veuillez essayer avec un fichier qui fait moins de 2 MB.');
                    $('.input-file .error-msg').fadeIn(300);
                    $(this).parent().parent().children('input').val('');
                }else {
                    $('.file-return span').html(this.files[0].name);
                    $('.file-return').fadeIn(300);
                    $('.input-file .error-msg').hide();
                    $('.file-return .remove').click(function() {
                        $('.file-return').fadeOut(300);
                        $(this).parent().parent().children('input').val('');
                    });
                }
            }else {
                $('.file-return span').html('');
                $('.file-return').fadeOut(300);
                $('.input-file .error-msg').html('Le format du fichier envoyé n\'est pas autorisé. <br/>Veuillez essayer avec un format autorisé (pdf, jpg, png, docx, xls ou csv).');
                $('.input-file .error-msg').fadeIn(300);
                $(this).parent().parent().children('input').val('');
            }
        });
    }

    // Fonction qui permet d'afficher les boutons de partage sur les fiches opérations
    function showShareButtons() {
        $('[data-social]').socialButtons();
        if($(this).hasClass('showBtns')) {
            $(this).removeClass('showBtns');
            $('.shareFacebook, .shareTwitter, .shareLinkedin, .shareEmail').removeClass('active');
        }else {
            $(this).addClass('showBtns');
            $('.shareFacebook, .shareTwitter, .shareLinkedin, .shareEmail').addClass('active');
        }
    }

    // Fonction qui permet de dérouler le texte en savoir plus
    function readMoreText() {
        if($('.readMoreIntroduction').hasClass('active')) {
            $(this).removeClass('active');
            $(this).children('span').html('Lire la suite...');
            $('.readMoreIntroduction').removeClass('active');
            $('.readMoreIntroduction').slideUp(300);
        }else {
            $(this).addClass('active');
            $(this).children('span').html('Replier le texte...');
            $('.readMoreIntroduction').addClass('active');
            $('.readMoreIntroduction').slideDown(300);
        }
    }

    // Fonction qui permet de dérouler le texte Lire la suite d'une opération
    function readMoreTextProject() {
        if($('.readMore').hasClass('active')) {
            $(this).removeClass('active');
            $(this).children('span').html('Lire la suite...');
            $('.readMore').removeClass('active');
            var offset = $('.projectdetails-infos .description').offset().top - 300;
            $('html, body').animate({scrollTop: offset}, 1000, function() { $('.readMore').slideUp(400); });
        }else {
            $(this).addClass('active');
            $(this).children('span').html('Replier le texte...');
            $('.readMore').addClass('active');
            $('.readMore').slideDown(300);
        }
    }

    // Fonction qui permet de gérer le scroll sur les ancres
    function goestoAnchor(e) {
        var navlink = $(this);
        var url = $(this).attr('href');
        if(url.indexOf('#') != -1) {
            e.preventDefault();
            var offset = $(url).offset().top - (headerHeight + 30);
            $('html, body').animate({scrollTop: offset}, 1200, function() {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + url;
                window.history.pushState({path:newurl},'',newurl);
                $('.navigationpage .subnav li.current').removeClass('current');
                navlink.parent().addClass('current');
            });
        }
    }

    // Fonction qui permet de sticker la map au scroll dans les fiches opérations
    function stickyMapProject() {
        if($('.projectdetails-map').length != 0 && $(window).width() >= 1200) {
            var unstickToBottom = false;
            var leftDiff = 15;

            if($('.projectdetails-map:not(.fullSizeMap)').hasClass('stickyMap') == false) {
                mapProjectPositionTop = $('.projectdetails-map:not(.fullSizeMap)').offset().top;
                mapProjectPositionLeft = $('.projectdetails-map:not(.fullSizeMap)').offset().left;
            }

            if($(this).scrollTop() >= mapProjectPositionTop - 50) {
                $('.projectdetails-map:not(.fullSizeMap)').css('left', parseInt(mapProjectPositionLeft) - leftDiff + 'px');
                $('.projectdetails-map:not(.fullSizeMap)').addClass('stickyMap');
            }else if($(this).scrollTop() <= (mapProjectPositionTop - 50)) {
                $('.projectdetails-map:not(.fullSizeMap)').removeClass('stickyMap');
                $('.projectdetails-map:not(.fullSizeMap)').removeAttr('style');
            }

            if($(this).scrollTop() >= (parseInt($('.projectdetails').next().offset().top) - 650)) {
                unstickToBottom = true;
                if(unstickToBottom) {
                    $('.projectdetails-map:not(.fullSizeMap)').removeAttr('style');
                    $('.projectdetails-map:not(.fullSizeMap)').addClass('attachedToBottom');
                }
            }else if($(this).scrollTop() >= mapProjectPositionTop - 50 && $(this).scrollTop() < (parseInt($('.projectdetails').next().offset().top) - 650)) {
                unstickToBottom = false;
                $('.projectdetails-map:not(.fullSizeMap)').removeAttr('style');
                $('.projectdetails-map:not(.fullSizeMap)').removeClass('attachedToBottom');
                $('.projectdetails-map:not(.fullSizeMap)').css('left', parseInt(mapProjectPositionLeft) - leftDiff + 'px');
                $('.projectdetails-map:not(.fullSizeMap)').addClass('stickyMap');
            }
        }
    }

    // Fonction qui permet de scroller jusqu'au contenu après la map
    function scrollToNextContent() {
        var offset = $(this).parent().next().offset().top - 140;
        $('html, body').animate({scrollTop: offset}, 1200);
    }

    // Fonction qui permet d'afficher la carte en fullscreen mobile
    function showMapOnMobile() {
        $('.mapcontainer').fadeIn(300);
        $('.mapcontaineriframe').fadeIn(300);
        if($('.mapcontaineriframe iframe').hasClass('is-loaded') === false) {
            $('.mapcontaineriframe .fadebg').fadeIn(200);
            $('.mapcontaineriframe iframe').on("load", function() {
                $(this).addClass('is-loaded');
                $('.mapcontaineriframe .fadebg').fadeOut(200);
            });
        }
        reloadMap(window.location.href, '');
        $('html, body').css('overflow', 'hidden');
        $('.mapcontainer .btn-closemap').click(function() {
            $('.mapcontainer').fadeOut(500, function() {
                $('html, body').removeAttr('style');
            });
        });
        $('.mapcontaineriframe .btn-closemap').click(function() {
            $('.mapcontaineriframe').fadeOut(500, function() {
                $('.mapcontaineriframe .fadebg').remove();
                $('html, body').removeAttr('style');
            });
        });
    }

    // Fonction qui permet d'adapter la taille des vidéos IFRAME dans les blocs WYSIWYG
    function adaptVideoSizeWysiwyg() {
        clearInterval(adaptVideoYoutubeSize);
        var $allVideos = $(".wysiwyg iframe");
        $allVideos.each(function() {
            if($(this).attr('src').indexOf('youtube') != -1 || $(this).attr('src').indexOf('dailymotion') != -1 || $(this).attr('src').indexOf('vimeo') != -1) {
                $(this)
                    .data('aspectRatio', 315 / 560)
                    .removeAttr('height')
                    .removeAttr('width');
            }
        });

        $(window).resize(function() {
            $(".wysiwyg iframe").removeAttr('style');
            var newWidth = $(".wysiwyg iframe").parent().innerWidth();
            $allVideos.each(function() {
                if($(this).attr('src').indexOf('youtube') != -1 || $(this).attr('src').indexOf('dailymotion') != -1 || $(this).attr('src').indexOf('vimeo') != -1) {
                    var $el = $(this);
                    $el
                        .width(newWidth)
                        .height(newWidth * $el.data('aspectRatio'));
                }

            });
            $(".wysiwyg iframe").each(function() {
                if($(this).attr('src').indexOf('youtube') != -1 || $(this).attr('src').indexOf('dailymotion') != -1 || $(this).attr('src').indexOf('vimeo') != -1) {
                    var $el = $(this);
                    $el
                        .css('width', $(this).children('iframe').css('width'))
                        .css('height', $(this).children('iframe').css('height'));
                }
            });
        }).resize();
    }

    // fonction pour l'effet liquid gooey
    function liquidGooey() {
        "use strict";
        var t, i = {
                screen: {
                    elem: null,
                    callback: null,
                    ctx: null,
                    width: 0,
                    height: 0,
                    left: 0,
                    top: 0,
                    init: function(t, i, s) {
                        return this.elem = document.getElementById(t), this.callback = i || null, "CANVAS" === this.elem.tagName && (this.ctx = this.elem.getContext("2d")), window.addEventListener("resize", function() {
                            this.resize()
                        }.bind(this), !1), this.elem.onselectstart = function() {
                            return !1
                        }, this.elem.ondrag = function() {
                            return !1
                        }, s && this.resize(), this
                    },
                    resize: function() {
                        var t = this.elem;
                        for (this.width = t.offsetWidth, this.height = t.offsetHeight, this.left = 0, this.top = 0; null != t; t = t.offsetParent) this.left += t.offsetLeft, this.top += t.offsetTop;
                        this.ctx && (this.elem.width = this.width, this.elem.height = this.height), this.callback && this.callback()
                    }
                }
            },
            s = function(t, i) {
                this.x = t, this.y = i, this.magnitude = t * t + i * i, this.computed = 0, this.force = 0
            };
        s.prototype.add = function(t) {
            return new s(this.x + t.x, this.y + t.y)
        };
        var h = function(t) {
            var i = .1,
                h = 1.5;
            this.vel = new s((Math.random() > .5 ? 1 : -1) * (.2 + .25 * Math.random()), (Math.random() > .5 ? 1 : -1) * (.2 + Math.random())), this.pos = new s(.2 * t.width + Math.random() * t.width * .6, .2 * t.height + Math.random() * t.height * .6), this.size = t.wh / 15 + (1.4 * Math.random() + .1) * (t.wh / 15), this.width = t.width, this.height = t.height
        };
        h.prototype.move = function() {
            this.pos.x >= this.width - this.size ? (this.vel.x > 0 && (this.vel.x = -this.vel.x), this.pos.x = this.width - this.size) : this.pos.x <= this.size && (this.vel.x < 0 && (this.vel.x = -this.vel.x), this.pos.x = this.size), this.pos.y >= this.height - this.size ? (this.vel.y > 0 && (this.vel.y = -this.vel.y), this.pos.y = this.height - this.size) : this.pos.y <= this.size && (this.vel.y < 0 && (this.vel.y = -this.vel.y), this.pos.y = this.size), this.pos = this.pos.add(this.vel)
        };
        var e = function(t, i, e, o, n) {
            this.step = 5, this.width = t, this.height = i, this.wh = Math.min(t, i), this.sx = Math.floor(this.width / this.step), this.sy = Math.floor(this.height / this.step), this.paint = !1, this.metaFill = r(t, i, t, o, n), this.plx = [0, 0, 1, 0, 1, 1, 1, 1, 1, 1, 0, 1, 0, 0, 0, 0], this.ply = [0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 1, 1, 0, 1, 0, 1], this.mscases = [0, 3, 0, 3, 1, 3, 0, 3, 2, 2, 0, 2, 1, 1, 0], this.ix = [1, 0, -1, 0, 0, 1, 0, -1, -1, 0, 1, 0, 0, 1, 1, 0, 0, 0, 1, 1], this.grid = [], this.balls = [], this.iter = 0, this.sign = 1;
            for (var a = 0; a < (this.sx + 2) * (this.sy + 2); a++) this.grid[a] = new s(a % (this.sx + 2) * this.step, Math.floor(a / (this.sx + 2)) * this.step);
            for (var l = 0; l < e; l++) this.balls[l] = new h(this)
        };
        e.prototype.computeForce = function(t, i, s) {
            var h, e = s || t + i * (this.sx + 2);
            if (0 === t || 0 === i || t === this.sx || i === this.sy) h = .6 * this.sign;
            else {
                h = 0;
                for (var r = this.grid[e], o = 0, n; n = this.balls[o++];) h += n.size * n.size / (-2 * r.x * n.pos.x - 2 * r.y * n.pos.y + n.pos.magnitude + r.magnitude);
                h *= this.sign
            }
            return this.grid[e].force = h, h
        }, e.prototype.marchingSquares = function(t) {
            var i = t[0],
                s = t[1],
                h = t[2],
                e = i + s * (this.sx + 2);
            if (this.grid[e].computed === this.iter) return !1;
            for (var r, o = 0, n = 0; n < 4; n++) {
                var l = i + this.ix[n + 12] + (s + this.ix[n + 16]) * (this.sx + 2),
                    d = this.grid[l].force;
                (d > 0 && this.sign < 0 || d < 0 && this.sign > 0 || !d) && (d = this.computeForce(i + this.ix[n + 12], s + this.ix[n + 16], l)), Math.abs(d) > 1 && (o += Math.pow(2, n))
            }
            if (15 === o) return [i, s - 1, !1];
            5 === o ? r = 2 === h ? 3 : 1 : 10 === o ? r = 3 === h ? 0 : 2 : (r = this.mscases[o], this.grid[e].computed = this.iter);
            var p = this.step / (Math.abs(Math.abs(this.grid[i + this.plx[4 * r + 2] + (s + this.ply[4 * r + 2]) * (this.sx + 2)].force) - 1) / Math.abs(Math.abs(this.grid[i + this.plx[4 * r + 3] + (s + this.ply[4 * r + 3]) * (this.sx + 2)].force) - 1) + 1);
            return a.lineTo(this.grid[i + this.plx[4 * r] + (s + this.ply[4 * r]) * (this.sx + 2)].x + this.ix[r] * p, this.grid[i + this.plx[4 * r + 1] + (s + this.ply[4 * r + 1]) * (this.sx + 2)].y + this.ix[r + 4] * p), this.paint = !0, [i + this.ix[r + 4], s + this.ix[r + 8], r]
        }, e.prototype.renderMetaballs = function() {
            for (var t = 0, i; i = this.balls[t++];) i.move();
            for (this.iter++, this.sign = -this.sign, this.paint = !1, a.fillStyle = this.metaFill, a.beginPath(), t = 0; i = this.balls[t++];) {
                var s = [Math.round(i.pos.x / this.step), Math.round(i.pos.y / this.step), !1];
                do {
                    s = this.marchingSquares(s)
                } while (s);
                this.paint && (a.fill(), a.closePath(), a.beginPath(), this.paint = !1)
            }
        };
        var r = function(t, i, s, h, e) {
                var r = a.createRadialGradient(t / 1, i / 1, 0, t / 1, i / 1, s);
                return r.addColorStop(0, h), r.addColorStop(1, e), r
            },
            o = function() {
                requestAnimationFrame(o), a.clearRect(0, 0, n.width, n.height), t.renderMetaballs()
            },
            n = i.screen.init("liquid", null, !0),
            a = n.ctx;
        n.resize(), t = new e(n.width, n.height, 6, "#b80e80", "#7F0A58"), o()
    }
